<template>
  <div class="multitag">
    <div class="desktop-layout">
      <desktop-layout
        :disable-close="disableClose"
        :tags="sortedMultitag"
        :i18n-field-value="i18nFieldValue"
        :get-action-mutate="getActionMutate"
        :is-joor-action-tag="isJoorActionTagFn"
        :custom-setting="customSetting"
        @close="$emit('close')"
      />
    </div>
    <div class="mobile-layout">
      <mobile-layout
        :disable-close="disableClose"
        :tags="sortedMultitag"
        :i18n-field-value="i18nFieldValue"
        :get-action-mutate="getActionMutate"
        :is-joor-action-tag="isJoorActionTagFn"
        :custom-setting="customSetting"
        @close="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import DesktopLayout from './Desktop'
import MobileLayout from './Mobile'

export default {
  name: 'ViewerLayerMultitag',
  components: {
    DesktopLayout,
    MobileLayout
  },
  props: {
    multitag: {
      type: Object,
      default: () => ({})
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    getActionMutate: {
      type: Function,
      default: () => {}
    },
    isJoorActionTag: {
      type: Function,
      default: () => {}
    },
    customSetting: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      lang: this.$i18n.locale
    }
  },
  computed: {
    sortedMultitag () {
      const tags = this.multitag.multitagInfo.filter(tag => !tag.hidden)
      const index = tags.findIndex(tag => tag.mainPhoto)
      const mainTagIndex = index > -1 ? index : 0
      const mainTag = tags.splice(mainTagIndex, 1)
      return [
        ...mainTag,
        ...tags
      ]
    },
    isJoorActionTagFn () {
      return this.isJoorActionTag || function () { return false } // Return false in TourRing, because TourRing doesn't pass function.
    }
  },
  methods: {
    i18nFieldValue (tag, field) {
      const i18nKey = field + 'Multi'
      const i18n = tag[i18nKey]
      if (i18n) {
        if (i18n[this.lang] === undefined) {
          return tag[field]
        } else {
          return i18n[this.lang]
        }
      }
      return tag[field]
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'

.multitag {
  height: 100%
}
.desktop-layout, .mobile-layout {
  height: 100%
}
.desktop-layout {
  display: block
}
.mobile-layout {
  display: none
}

@media (max-width: 430px) {
  .desktop-layout {
    display: none
  }
  .mobile-layout {
    display: block
  }
}

</style>
